import { Head } from "vite-react-ssg"

import { LegalPage } from "@/components/LegalPage"
import { usePrivacyPolicy } from "@/lib/queries/legal"

/**
 * Privacy Policy.
 *
 * The page chrome (breadcrumb, heading) is statically prerendered by
 * vite-react-ssg; the policy body fetches from `GET /app/privacy_policy`
 * after hydration. Admins editing the policy in admin-v2 see the change
 * here without a redeploy.
 */
export function Component() {
  const query = usePrivacyPolicy()
  return (
    <>
      <Head>
        <title>Privacy Policy — Good Talk</title>
        <meta
          name="description"
          content="How Good Talk collects, uses, and protects your information."
        />
        <link rel="canonical" href="https://goodtalk.coach/privacy" />
      </Head>
      <LegalPage title="Privacy Policy" query={query} />
    </>
  )
}
